module.exports = __webpack_public_path__ + "img/monster.84d51b69.svg";